import styled from '@emotion/styled';
import { DefaultComponentVariantType, InputVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';


type StakeInputPropsType = {
    variant: typeof InputVariantType[keyof typeof InputVariantType];
    betslipVariant: DefaultComponentVariantType | null;
}

export const StakeInputWrapper = withConfig(theme => styled('div', { label: 'StakeInputWrapper' })<StakeInputPropsType>`
    align-items: center;
    background-color: ${theme.star.form.dark.bgColor};
    display: flex;
    flex: 1 1 0%;
    height: ${({ betslipVariant }): string => betslipVariant === DefaultComponentVariantType.SECONDARY ? '36px' : '40px'};
    justify-content: space-between;
    padding: 0 10px;
    border-radius: ${({ variant }): string => variant === InputVariantType.SECONDARY ? '4px': '0'};
`);


export const CurrencyStyle = withConfig(theme => styled('div', { label: 'CurrencyStyle' })`
    color: ${theme.star.form.bgColorTertiary};
    font-size: ${theme.star.fontSize.xRegular};
    font-weight: ${theme.star.fontWeight.bold};
`);

export const StakeInputStyle = withConfig(theme => styled('input', { label: 'StakeInputStyle' })`
    background-color: ${theme.star.form.dark.bgColor};
    border: 0;
    color: ${theme.star.betslipGeneral.txtColorSecondary};
    font-size: ${theme.star.fontSize.xRegular};
    font-weight: ${theme.star.fontWeight.bold};
    height: 100%;
    line-height: 1;
    min-width: 50px;
    text-align: right;
    width: 100%;
    &::placeholder {
        color: ${theme.star.form.txtColorSecondary};
    }
`);
